/* One AddToCart per shopper action, for every add path in the theme.
   Every buy box, bundle builder, listicle and lander adds through POST /cart/add(.js). This watches
   those requests and, per successful add, emits a single event that carries the whole add:
     - window.ElevarDataLayer  dl_add_to_cart (Elevar sends it to the Meta pixel and to CAPI with the
       same event_id, so Meta dedupes the pair)
     - Shopify.analytics.publish('jive_add_to_cart')  for custom pixels (e.g. Blotout) that want the
       same single event and event_id instead of Shopify's per-line product_added_to_cart
     - document 'jive:add-to-cart' CustomEvent  for theme code
   While Elevar's own "Add to cart" auto-tracking is still on it already pushes dl_add_to_cart for the
   PDP form; when it did so for this add, the Elevar push here is skipped so Elevar never sees two.
   Elevar's cart reconcile would later re-send every line it did not see added (one dl_add_to_cart per
   line on the next page, gifts included), so its stored cart snapshot is brought up to date here.
   Free-gift lines ($0, or flagged with a *free_gift property) are left out of contents and value; an
   add that only contains gifts emits nothing. Quantity changes in the cart (/cart/change.js) are not
   adds and emit nothing. */
(function () {
  if (window.JiveATC) return;
  var ADD_PATH = /\/cart\/add(\.js)?$/;
  var GIFT_PROPERTY = /free_?gift/i;
  var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

  function eventId() {
    if (window.crypto && crypto.randomUUID) return 'jive-atc-' + crypto.randomUUID();
    return 'jive-atc-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  }

  function isAdd(url, method) {
    if (!url || String(method || 'GET').toUpperCase() !== 'POST') return false;
    try { return ADD_PATH.test(new URL(url, location.href).pathname); } catch (e) { return false; }
  }

  // Requested lines from any body shape the theme and apps send: JSON {items}/{id}, FormData, urlencoded.
  function requestedLines(body) {
    var lines = [];
    var push = function (id, quantity, properties) {
      if (id) lines.push({ id: String(id), quantity: Math.max(1, parseInt(quantity, 10) || 1), properties: properties || {} });
    };
    var fromPairs = function (pairs) {
      var items = {};
      var single = { properties: {} };
      pairs.forEach(function (pair) {
        var key = pair[0], value = pair[1];
        var item = key.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
        var itemProp = key.match(/^items\[(\d+)\]\[properties\]\[(.+)\]$/);
        var prop = key.match(/^properties\[(.+)\]$/);
        if (item) { items[item[1]] = items[item[1]] || { properties: {} }; items[item[1]][item[2]] = value; }
        else if (itemProp) { items[itemProp[1]] = items[itemProp[1]] || { properties: {} }; items[itemProp[1]].properties[itemProp[2]] = value; }
        else if (prop) single.properties[prop[1]] = value;
        else if (key === 'id' || key === 'quantity') single[key] = value;
      });
      Object.keys(items).forEach(function (k) { push(items[k].id, items[k].quantity, items[k].properties); });
      if (single.id) push(single.id, single.quantity, single.properties);
    };
    try {
      if (typeof body === 'string') {
        if (/^\s*\{/.test(body)) {
          var json = JSON.parse(body);
          if (Array.isArray(json.items)) json.items.forEach(function (i) { push(i.id || i.variant_id, i.quantity, i.properties); });
          else push(json.id || json.variant_id, json.quantity, json.properties);
        } else fromPairs(Array.from(new URLSearchParams(body)));
      } else if (window.FormData && body instanceof FormData) fromPairs(Array.from(body.entries()));
      else if (body instanceof URLSearchParams) fromPairs(Array.from(body));
    } catch (e) { /* An unreadable body falls back to the response lines below. */ }
    return lines;
  }

  // dl_add_to_cart pushes made by Elevar itself (ours carry a jive-atc- event_id).
  function elevarOwnAdds() {
    return (window.ElevarDataLayer || []).filter(function (e) {
      return e && e.event === 'dl_add_to_cart' && !/^jive-atc-/.test(e.event_id || '');
    }).length;
  }

  // Elevar keeps the cart it last saw in localStorage and, on the next page, re-sends any difference
  // as dl_add_to_cart per line. Record the lines Shopify just returned so that add is not sent twice.
  var ELEVAR_CART = '___ELEVAR_GTM_SUITE--cart';
  function syncElevarCart(returned) {
    try {
      var stored = localStorage.getItem(ELEVAR_CART);
      if (stored == null) return;
      var snapshot = JSON.parse(stored);
      if (!Array.isArray(snapshot)) return;
      var totals = {};
      returned.forEach(function (line) {
        var id = String(line.variant_id);
        if (!totals[id]) totals[id] = { line: line, quantity: 0 };
        totals[id].quantity += Number(line.quantity) || 0;
      });
      var next = snapshot.filter(function (entry) { return !totals[String(entry.variantId)]; });
      Object.keys(totals).forEach(function (id) {
        var line = totals[id].line;
        var previous = snapshot.find(function (entry) { return String(entry.variantId) === id; });
        next.push({
          id: line.sku || id,
          name: line.product_title || line.title,
          brand: line.vendor || '',
          category: line.product_type || '',
          variant: line.variant_title || 'Default Title',
          price: (line.price / 100).toFixed(2),
          productId: String(line.product_id),
          variantId: id,
          compareAtPrice: line.original_price && line.original_price > line.price ? (line.original_price / 100).toFixed(2) : '0.0',
          image: line.image || null,
          url: line.url || '',
          quantity: String(totals[id].quantity),
          list: previous ? previous.list : location.pathname,
        });
      });
      localStorage.setItem(ELEVAR_CART, JSON.stringify(next));
    } catch (e) { /* Elevar changed its storage; reconcile then behaves as before. */ }
  }

  function isGift(line, properties) {
    var props = Object.assign({}, line.properties || {}, properties || {});
    if (Object.keys(props).some(function (key) { return GIFT_PROPERTY.test(key) && props[key] !== '' && props[key] != null; })) return true;
    var unit = line.final_price != null ? line.final_price : line.discounted_price != null ? line.discounted_price : line.price;
    return Number(unit) === 0;
  }

  function track(body, data, elevarBefore) {
    var returned = data && Array.isArray(data.items) ? data.items : data && (data.variant_id || data.id) ? [data] : [];
    if (!returned.length) return;
    var asked = requestedLines(body);
    var used = [];
    var products = [];
    returned.forEach(function (line) {
      // Shopify returns the merged cart quantity for a line, so the added quantity comes from the request.
      var index = asked.findIndex(function (a, i) { return used.indexOf(i) === -1 && a.id === String(line.variant_id || line.id); });
      var request = index === -1 ? null : asked[index];
      if (index !== -1) used.push(index);
      if (isGift(line, request && request.properties)) return;
      var quantity = request ? request.quantity : asked.length ? 0 : line.quantity;
      if (!quantity) return;
      var unit = line.final_price != null ? line.final_price : line.price;
      products.push({
        id: line.sku || String(line.variant_id),
        name: line.product_title || line.title,
        brand: line.vendor || '',
        category: line.product_type || '',
        variant: line.variant_title || '',
        price: (unit / 100).toFixed(2),
        quantity: String(quantity),
        list: location.pathname,
        product_id: String(line.product_id),
        variant_id: String(line.variant_id),
        image: line.image || line.featured_image && line.featured_image.url || '',
        url: line.url ? new URL(line.url, location.origin).toString() : '',
        _unit: unit,
      });
    });
    if (!products.length) return;

    var id = eventId();
    var value = products.reduce(function (sum, p) { return sum + p._unit * Number(p.quantity); }, 0) / 100;
    products.forEach(function (p) { delete p._unit; });
    var detail = { event_id: id, value: Number(value.toFixed(2)), currency: currency, products: products };

    window.ElevarDataLayer = window.ElevarDataLayer || [];
    if (elevarBefore == null || elevarOwnAdds() === elevarBefore) {
      window.ElevarDataLayer.push({
        event: 'dl_add_to_cart',
        event_id: id,
        ecommerce: { currencyCode: currency, add: { actionField: { list: location.pathname }, products: products } },
      });
      syncElevarCart(returned);
    }
    try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish('jive_add_to_cart', detail); } catch (e) {}
    document.dispatchEvent(new CustomEvent('jive:add-to-cart', { detail: detail }));
  }

  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input, init) {
      var request = nativeFetch.apply(this, arguments);
      var url = typeof input === 'string' ? input : input && input.url;
      var method = (init && init.method) || (input && input.method);
      if (isAdd(url, method)) {
        var body = init && init.body;
        var before = elevarOwnAdds();
        request.then(function (response) {
          if (response.ok) response.clone().json().then(function (data) { track(body, data, before); }).catch(function () {});
        }).catch(function () {});
      }
      return request;
    };
  }

  var open = XMLHttpRequest.prototype.open;
  var send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._jiveAdd = isAdd(String(url), method);
    return open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    if (this._jiveAdd) {
      var before = elevarOwnAdds();
      this.addEventListener('load', function () {
        if (this.status < 200 || this.status >= 300) return;
        try { track(body, typeof this.response === 'object' && this.response ? this.response : JSON.parse(this.responseText), before); } catch (e) {}
      });
    }
    return send.apply(this, arguments);
  };

  window.JiveATC = { track: track };
})();
